export class FieldError {
    validationName: string;
    message: string;

    constructor(validationName: string, message: string) {
        this.validationName = validationName;
        this.message = message;
    }
}